import {Component, Inject, ViewEncapsulation} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {AuthService} from '../../core/auth/auth.service';
import {Router} from '@angular/router';
import {fuseAnimations} from '@fuse/animations';
import {ErrorDialogData} from './error-dialog.types';

import { MatIcon } from '@angular/material/icon';
import { MatIconButton } from '@angular/material/button';
import { BypassSecurityTrustHtmlPipe } from '../../pipes/bypass-security-trust-html.pipe';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
    selector: 'app-error-dialog',
    templateUrl: './error-dialog.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    standalone: true,
    imports: [MatIconButton, MatIcon, BypassSecurityTrustHtmlPipe, TranslocoPipe],
})
export class ErrorDialogComponent {

    constructor(
        public dialogRef: MatDialogRef<ErrorDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: ErrorDialogData,
        private _authService: AuthService,
        private _router: Router
    ) {

    }

    checkIfNeedToLogin(): void {
        if (this.data.agaveErrorCode === '001' ||
            this.data.agaveErrorCode === 'D01' ||
            this.data.agaveErrorCode === '010' ||
            this.data.agaveErrorCode === 'D10' ||
            this.data.message === 'AUTHENTICATION') {

            this._authService.signOut();
            this._router.navigate(['sign-in']);
        }
    }
}
